export function newsletterModal() {

    let $form = $(".footer-form");
    let $input = $form.find("input[type='email']");
    let $submitButton = $form.find("input[type='button']");
    let $modal = $("#newsletter-modal");
    let $newsForm = $(".newsleter-form");
    let $checkboxField = $modal.find(".gfield_checkbox");
    let checkboxFieldInput = $checkboxField.find("input");
    let checkboxFieldLabel = $checkboxField.find("label");
    let $modalEmailField = $modal.find(".ginput_container_email > input");
    let $modalEmaillabel = $modalEmailField.closest(".form-field").find(".gfield_label");
    let $modalCloseButton = $modal.find(".modal-window-close");
    let $openModalBtnInHero = $(".open-newsletter-modal");
    let email;
    let ifFormHasError = $modal.find(".gform_validation_error");
    let ifFormHasSuccess = $modal.find(".gform_confirmation_wrapper");
    let ifValidEmail = function (email) {
        let pattern  = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(email);
    };

    if (ifFormHasError.length || ifFormHasSuccess.length) {
        $modal.addClass("open");
    }

    if ($newsForm.length > 1) {
        checkboxFieldInput.attr("id", checkboxFieldInput.attr("id") + 1);
        checkboxFieldLabel.attr("for", checkboxFieldInput.attr("id"));
    }

    if ($openModalBtnInHero.length) {
        $openModalBtnInHero.on("click", function (e) {
            e.preventDefault();
            $modal.addClass("open");
        });
    }

    $submitButton.on("click", function (e) {
        let $result = ifValidEmail($input.val());
        e.preventDefault();

        if ($result) {
            email = $input.val();
            $modal.addClass("open");
            $form.removeClass("invalid");
            $modalEmailField.val(email);
            $modalEmaillabel.addClass("hide");
        } else {
            $form.addClass("invalid");
        }
    });

    $form.on("keydown", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    $modalCloseButton.on("click", function () {
        $modal.removeClass("open");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/newsletterModal.js